export const KEY_HANDOVER_GUIDANCE = '鍵のご案内'

export const KEY_HANDOVER_DOCUMENT_1 = '鍵の引き渡しのご案内'
export const KEY_HANDOVER_DOCUMENT_2 = '当社での鍵の受取りの際のご注意点'
export const KEY_HANDOVER_DOCUMENT_3 = '鍵のご案内'